/* eslint-disable no-console */
import React, { useState } from 'react'
import SearchContext from './SearchContext'
import { mongodb, client, useAuth } from './Auth//use-auth'
import Timeline, {
  TimelineHeaders,
  DateHeader,
  TimelineMarkers,
  TodayMarker,
  CustomMarker,
  CursorMarker,
  CustomHeader,
  // SidebarHeader,
  scrollRef
} from 'react-calendar-timeline'
import InfoLabel from './components/InfoLabel'
import moment from 'moment'
import 'moment/locale/et'
import { keys, minTime, maxTime, randomInt } from './constants'
import Container from '@material-ui/core/Container'
import { makeStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Snackbar from '@material-ui/core/Snackbar'
import Alert from '@material-ui/lab/Alert'
import { useHistory } from 'react-router-dom'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex'
  },
  container: {
    paddingTop: 30,
    paddingBottom: 20,
    marginTop: 40
  },

  buttonrow: {
    padding: theme.spacing(1),
    marginLeft: '10px',
    marginTop: '10px',
    marginBottom: '10px'
  }
}))
function MainCalendar (props) {
  const classes = useStyles()
  // const { auth, user } = useAuth()
  const { globalFilter, selectedDate, setSelectedDate } = React.useContext(
    SearchContext
  )
  const user = 'Kasutaja'
  const history = useHistory()
  const [groups, setGroups] = useState([{}])
  const [items, setItems] = useState([{}])
  const [db] = useState(mongodb.db('silmandDB'))
  const [selected, setSelected] = useState([])
  const [selectInfo, setSelectInfo] = useState([])
  const [draggedItem, setDraggedItem] = useState(undefined)
  const [checkedSlide, setCheckedSlide] = React.useState(false)
  const [visibleTimeStart, setVisibleTimeStart] = useState(
    moment(selectedDate)
      .startOf('day')
      .add(5, 'hour')
      .valueOf()
  )
  const [visibleTimeEnd, setVisibleTimeEnd] = useState(
    moment(selectedDate)
      .startOf('day')
      .add(1, 'day')
      .add(-3, 'hour')
      .valueOf()
  )
  // canvas
  //const [canvasTimeStart, setCanvasTimeStart] = useState()
  //const [canvasTimeEnd, setCanvasTimeEnd] = useState()

  //---------------

  const mobile = /Mobile|mini|Fennec|Android|iP(ad|od|hone)/.test(
    navigator.appVersion
  )

  React.useEffect(() => {
    if (user) {
      displayGroups()
      displayItems(globalFilter)
    } else {
      console.log('ei toimi user', user)
    }
  }, [globalFilter])

  React.useEffect(() => {
    if (user) {
      setVisibleTimeStart(
        moment(selectedDate)
          .startOf('day')
          .add(5, 'hour')
          .valueOf()
      )
      setVisibleTimeEnd(
        moment(selectedDate)
          .startOf('day')
          .add(1, 'day')
          .add(-3, 'hour')
          .valueOf()
      )
    } else {
      console.log('ei toimi user', user)
    }
  }, [selectedDate])

  const displayGroups = async () => {
    try {
      await db
        .collection('groups')
        .find({ hidden: false })
        .asArray()
        .then(gr => {
          setGroups(gr)
        })
    } catch (e) {
      console.log('item find viga', e)
    } finally {
    }
  }

  const displayItems = async filter => {
    try {
      if (filter.length !== 0) {
        console.log('filtriga', filter)
        await db
          .collection('items')
          .find({
            carNumber: { $regex: `^${filter}`, $options: 'i' }
          })
          .asArray()
          .then(itms => {
            setItems(itms)
          })
      } else {
        await db
          .collection('items')
          .find({})
          .asArray()
          .then(itms => {
            setItems(itms)
          })
      }
    } catch (e) {
      console.log('item find viga', e)
    } finally {
    }
    return items
  }

  //// andmete muutmine

  const addItem = async (groupId, time) => {
    if (globalFilter.length === 0) {
      try {
        await db.collection('items').insertOne({
          _id: parseInt(randomInt(1, 9)),
          owner_id: client.auth.user.id,
          group: groupId,
          title: `Registreerimisel`,
          start_time: time,
          end_time: time + 7200000,
          status: 0,
          bgColor: '#80cbc4'
        })
        await displayItems('')
      } catch (e) {
        console.log('item kirjutamise viga', e)
      }
    } else {
      window.alert('Filtriga ei saa lisada uut aega!')
    }
  }

  //k6igi andmete kustutamise helper nupu hndl
  // const handleDeleteItems = event => {
  //   event.preventDefault()
  //   try {
  //     db.collection('items')
  //       .deleteMany({})
  //       .then(displayItems())
  //   } catch (e) {
  //     console.log('item kirjutamise viga', e)
  //   } finally {
  //   }
  // }

  const handleCanvasDoubleClick = (groupId, time) => {
    addItem(groupId, time)
    //console.log('Lisatud grupp', groupId, moment(time).format())
  }

  const handleCanvasContextMenu = (group, time) => {
    console.log('Canvas context menu', group, moment(time).format())
  }

  const handleItemClick = (itemId, _, time) => {
    //console.log('Clicked: ' + itemId, moment(time).format())
  }

  const handleItemSelect = (itemId, e, time) => {
    setCheckedSlide(true)
    setSelected([itemId])
    let delayTimer = setTimeout(() => setCheckedSlide(true), 1)
    clearTimeout(delayTimer)
    items.map(
      (selCurInfo, i) =>
        selCurInfo._id === parseInt(itemId) &&
        setSelectInfo(
          [selCurInfo.title, selCurInfo.symptoms, selCurInfo.solved].join('\n')
        )
    )
    delayTimer = setTimeout(() => setCheckedSlide(false), 4000)

    // `${selCurInfo.title} '/n'
    //     ${selCurInfo.symptoms} '/n'
    //     ${selCurInfo.solved} `
    //selCurInfo.clientShortName ${selCurInfo.carNumber}
    //setSelected(prevValue => [...prevValue, itemId]) lisab juurde
    //setSelected([...selected, itemId]) mitu selectitud
    //console.log('Selected Lisatud: ', itemId, time, items)
  }

  const handleItemDeselect = e => {
    // this.setState({ selected: undefined })
    // console.log('Itemdeselct enne ', selected)
    setCheckedSlide(prev => !prev)
    setSelected([null])
    //console.log('Itemdeselct peale ', selected)
  }

  const handleItemDoubleClick = (itemId, e, time, props) => {
    // console.log(
    //   'Double Click: ' + itemId,
    //   moment(time).format(),
    //   e.currentTarget.children,
    //   items
    // )
    //items.find(itemId => items._id == itemId)
    setSelected([itemId])
    history.push('/update/' + itemId)
  }
  const handleItemContextMenu = (itemId, _, time) => {
     console.log('Context Menu: ' + itemId, moment(time).format())
  }
  const handleItemMove = async (itemId, dragTime, newGroupOrder) => {
    let actualItem = undefined //et saada pikkust

    const group = groups[newGroupOrder]
    setItems(
      items.map(item =>
        item._id === itemId
          ? (actualItem = Object.assign({}, item, {
              start_time: dragTime,
              end_time: dragTime + (item.end_time - item.start_time),
              group: group._id
            }))
          : item
      )
    )
    setDraggedItem(undefined)
    try {
      await db.collection('items').updateOne(
        { _id: itemId },
        {
          $set: {
            start_time: dragTime,
            end_time: dragTime + (actualItem.end_time - actualItem.start_time),
            group: group._id
          }
        }
      )
      await displayItems(globalFilter)

      //jätab ainult muudetud väärtuse kirjesse
    } catch (e) {
      console.log('item liigutamise', e)
    } finally {
      //console.log(`liigutatud- ${moment(dragTime).format()}`)
    }
  }

  const handleItemResize = async (itemId, time, edge) => {
    //console.log('idväärtus', itemId, time, edge)
    //debugger
    try {
      if (edge === 'right') {
        await db.collection('items').updateOne(
          { _id: itemId },
          {
            $set: {
              end_time: time
            }
          }
        )
        await displayItems(globalFilter)
      } else {
        await db.collection('items').updateOne(
          { _id: itemId },
          {
            $set: {
              start_time: time
            }
          }
        )
        await displayItems(globalFilter)
      }
      setDraggedItem(undefined)

      //jätab ainult muudetud väärtuse kirjesse
    } catch (e) {
      console.log('item kirjutamise viga', e)
    } finally {
      // console.log(`liigutatud-${edge}uus aeg - ${moment(time).format()}`)
      // console.log('displayGroups', JSON.stringify(groups))
    }
  }
  const handleItemDrag = ({ eventType, itemId, time, edge, newGroupOrder }) => {
    let item = draggedItem ? draggedItem.item : undefined
    if (!item) {
      item = items.find(i => i.id === itemId)
    }
    setDraggedItem({ item: item, group: groups[newGroupOrder], time })
  }
  // this limits the silmandDB to -6 months ... +6 months
  const handleTimeChange = (
    visibleTimeStart,
    visibleTimeEnd,
    updateScrollCanvas
  ) => {
    setVisibleTimeStart(visibleTimeStart)
    setVisibleTimeEnd(visibleTimeEnd)
    //setSelectedDate(visibleTimeStart)
    if (visibleTimeStart < minTime && visibleTimeEnd > maxTime) {
      updateScrollCanvas(minTime, maxTime)
    } else if (visibleTimeStart < minTime) {
      updateScrollCanvas(minTime, minTime + (visibleTimeEnd - visibleTimeStart))
    } else if (visibleTimeEnd > maxTime) {
      updateScrollCanvas(maxTime - (visibleTimeEnd - visibleTimeStart), maxTime)
    } else {
      updateScrollCanvas(visibleTimeStart, visibleTimeEnd)
    }
  }

  const handleTimeChangeMobile = (
    visibleTimeStart,
    visibleTimeEnd,
    updateScrollCanvas
  ) => {
    setVisibleTimeStart(visibleTimeStart)
    //setVisibleTimeEnd(visibleTimeEnd)
    // setSelectedDate(visibleTimeStart)
    setSelectedDate(visibleTimeStart)
    if (visibleTimeStart < minTime && visibleTimeEnd > maxTime) {
      updateScrollCanvas(minTime, maxTime)
    } else if (visibleTimeStart < minTime) {
      updateScrollCanvas(minTime, minTime + (visibleTimeEnd - visibleTimeStart))
    } else if (visibleTimeEnd > maxTime) {
      updateScrollCanvas(maxTime - (visibleTimeEnd - visibleTimeStart), maxTime)
    } else {
      updateScrollCanvas(visibleTimeStart, visibleTimeEnd)
    }
  }
  // // muutmise funktsioon
  //}
  // const moveResizeValidator = (action, item, time) => {
  //   // if (time < new Date().getTime()) {
  //   //   var newTime =
  //   //     Math.ceil(new Date().getTime() / (15 * 60 * 1000)) * (15 * 60 * 1000)
  //   //   console.log('moveResizeValidator newtime', action, newTime)
  //   //   return newTime
  //   // }
  //   console.log('moveResizeValidatortime', action, time)
  //   return //time
  // }
  const itemRenderer = ({
    item,
    timelineContext,
    itemContext,
    getItemProps,
    getResizeProps
  }) => {
    const { left: leftResizeProps, right: rightResizeProps } = getResizeProps()
    const backgroundColor = itemContext.selected
      ? itemContext.dragging
        ? 'red'
        : item.selectedBgColor
      : item.bgColor
    const borderColor = itemContext.resizing ? 'red' : item.color

    return (
      <div
        {...getItemProps({
          style: {
            backgroundColor,
            color: item.color,
            borderColor,

            borderRadius: 4,
            borderLeftWidth: itemContext.selected ? 3 : 1,
            borderRightWidth: itemContext.selected ? 3 : 1
          },
          onMouseDown: () => {
            //console.log('on item click rerender', item)
          }
        })}
      >
        {itemContext.useResizeHandle ? <div {...leftResizeProps} /> : null}

        <div
          style={{
            height: itemContext.dimensions.height,
            overflow: 'hidden',
            paddingLeft: 3,
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
          }}
        >
          {itemContext.title}
        </div>

        {itemContext.useResizeHandle ? <div {...rightResizeProps} /> : null}
      </div>
    )
  }
  const onPrevClick = () => {
    const zoom = visibleTimeEnd - visibleTimeStart
    setVisibleTimeStart(visibleTimeStart - zoom)
    setVisibleTimeEnd(visibleTimeEnd - zoom)
  }

  const onNextClick = () => {
    const zoom = visibleTimeEnd - visibleTimeStart
    setVisibleTimeStart(visibleTimeStart + zoom)
    setVisibleTimeEnd(visibleTimeEnd + zoom)
  }
  //const onPrevCanvas = (canvasTimeStart, canvasTimeEnd) => {
  // setCanvasTimeStart(canvasTimeStart - 179974559)
  // setCanvasTimeEnd(canvasTimeStart + 57600000)
  //updateScrollCanvas(canvasTimeStart, canvasTimeEnd)

  // const zoom = visibleTimeEnd - visibleTimeStart
  // setVisibleTimeStart(visibleTimeStart - zoom)
  // setVisibleTimeEnd(visibleTimeEnd - zoom)
  //}

  return (
    <Container key={'kontainer'} className={classes.container}>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={checkedSlide}
        key={'topcenter'}
        severity='info'
      >
        <Alert severity='info'>
          <div>{selectInfo}</div>
        </Alert>
      </Snackbar>

      <Button
        className={classes.buttonrow}
        variant='outlined'
        color='primary'
        id='prevbtn'
        onClick={onPrevClick}
      >
        {'< '}
      </Button>
      <Button
        className={classes.buttonrow}
        variant='outlined'
        color='primary'
        id='nextbtn'
        onClick={onNextClick}
      >
        {' >'}
      </Button>
      <Timeline
        key={555}
        groups={groups}
        items={items}
        keys={keys}
        fullUpdate
        sidebarWidth={100}
        canMove={mobile ? false : true}
        canResize={mobile ? false : 'both'}
        canSelect
        itemsSorted
        itemTouchSendsClick={false}
        itemRenderer={itemRenderer}
        stackItems={true}
        itemHeightRatio={0.8}
        visibleTimeStart={visibleTimeStart}
        visibleTimeEnd={visibleTimeEnd}
        onCanvasDoubleClick={handleCanvasDoubleClick}
        onCanvasContextMenu={handleCanvasContextMenu}
        onItemClick={handleItemClick}
        onItemContextMenu={handleItemContextMenu}
        onItemMove={handleItemMove}
        onItemResize={handleItemResize}
        onItemDoubleClick={handleItemDoubleClick}
        onTimeChange={mobile ? handleTimeChangeMobile : handleTimeChange}
        selected={selected}
        onItemSelect={handleItemSelect}
        onItemDeselect={handleItemDeselect}
        onItemDrag={handleItemDrag}
      >
        <TimelineHeaders className='sticky'>
          <DateHeader unit='primaryHeader' />

          <TimelineMarkers>
            <CursorMarker />
          </TimelineMarkers>
          <DateHeader />
        </TimelineHeaders>
      </Timeline>
      {draggedItem && (
        <InfoLabel
          item={draggedItem.item}
          group={draggedItem.group}
          time={draggedItem.time}
        />
      )}
      <div>
        {selected[0] > null && (
          <Button
            className={classes.buttonrow}
            variant='outlined'
            color='primary'
            id='openbtn'
            onClick={() => history.push('/update/' + selected)}
          >
            Ava Reserveering
          </Button>
        )}
      </div>
    </Container>
  )
}

export default MainCalendar
// <p> visibleTimestart {parseInt(visibleTimeStart)}</p>
// <p>visibleTimeend{parseInt(visibleTimeEnd)}</p>
// <p>selected date koos tyhikuga {JSON.stringify(selectedDate + '')}</p>
// <p>canvasstart {parseInt(canvasTimeStart)}</p>
// <p>canvasend{parseInt(canvasTimeEnd)}</p>
//   < h3 > { parseInt(visibleTimeStart) }</h3 >

//     <h3>{parseInt(visibleTimeEnd) - parseInt(visibleTimeStart)}</h3>
// { JSON.stringify(selectedDate + '') }
